module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg8.a99fa6d6.jpg";